import { Pagination } from "@mui/material";
import { UploadIcon } from "@radix-ui/react-icons";
import { WorkHistoryIcon } from "hugeicons-react";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  AJOUTER_SERVICE_PARTNER,
  CHARGER_LISTE_SERVICE_PARTNER,
  DELETE_SERVICE_PARTNER,
  RECHERCHER_SERVICE_PARTNER,
} from "../../Utils/constant";
import model from "../../assets/model-fichier/model.xlsx";
import { UpdateServicePartner } from "../../components/Forfait/UpdateServicePartner";
import { Loader } from "../../components/Widget/Loader";
import clientAxios from "../../services/axios";
import { store } from "../../services/service";
import { useStoreServicePartner } from "../../store/storeServicePartner";

export const ServicePartner = () => {
  const servicePartner = useStoreServicePartner();
  const [selectItem, setSelectItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [fichier, setFichier] = useState([]);
  const [message, setMessage] = useState("");

  const handleChangeFichier = (e) => {
    const newFiles = Array.from(e.target.files);
    setFichier((prev) => [...prev, ...newFiles]);
  };

  const submit = (data) => {
    setIsSubmit(true);
    store(AJOUTER_SERVICE_PARTNER, "application/json", data)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          document.getElementById("fermer_create_role").click();
          toast.success("Créé avec succès");
          servicePartner.getData(
            `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`,
          );
        }
      })
      .catch((err) => {
        document.getElementById("fermer_create_role").click();
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  useEffect(() => {
    servicePartner.getData(
      `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`,
    );
  }, []);

  const more = (page) => {
    servicePartner.getData(
      `${RECHERCHER_SERVICE_PARTNER}?page=${page - 1}&param=&size=10`,
    );
  };

  const inputCls =
    "w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition";

  return (
    <>
      {/* Header */}
      <div className="mt-4 mb-1">
        <p className="text-2xl font-bold text-gray-900 tracking-tight">
          Service Partners
        </p>
        <p className="text-sm text-gray-400 mt-1">
          Gestion des services partenaires
        </p>
      </div>

      {/* Toolbar */}
      <div className="flex flex-wrap items-center gap-3 py-4 border-b border-gray-100 mb-6">
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 h-10">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9ca3af"
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <input
            onChange={(e) =>
              servicePartner.getData(
                `${RECHERCHER_SERVICE_PARTNER}?page=0&param=${e.target.value}&size=10`,
              )
            }
            type="text"
            placeholder="Rechercher un service partner…"
            className="bg-transparent border-none outline-none text-sm text-gray-900 placeholder-gray-400 w-52"
          />
        </div>

        <div className="ml-auto flex items-center gap-2">
          {/* Upload bulk button */}
          <button
            onClick={() => document.getElementById("upload").showModal()}
            className="h-10 px-4 flex items-center gap-2 bg-gray-900 hover:bg-gray-700 text-white text-sm font-medium rounded-xl transition"
          >
            <UploadIcon />
            Charger par lot
          </button>

          {/* Add button */}
          <button
            onClick={() => document.getElementById("add").showModal()}
            className="h-10 px-4 bg-yellow-400 hover:bg-yellow-300 text-gray-900 text-sm font-semibold rounded-xl transition"
          >
            Ajouter
          </button>
        </div>
      </div>

      {/* Upload Modal */}
      <dialog id="upload" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-lg">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              Charger un fichier
            </h2>
            <form method="dialog">
              <button
                id="close_upload"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition"
              >
                ✕
              </button>
            </form>
          </div>

          {message && <p className="text-xs text-red-500 mb-3">{message}</p>}

          {/* Drop zone */}
          <label className="block w-full cursor-pointer">
            <div className="border-2 border-dashed border-gray-200 bg-gray-50 rounded-xl p-8 flex flex-col items-center gap-3 hover:border-yellow-400 hover:bg-yellow-50 transition">
              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-400">
                <UploadIcon />
              </div>
              <p className="text-sm text-gray-500 font-medium">
                {fichier.length > 0 ? (
                  <span className="text-yellow-600 font-semibold">
                    {fichier[0]?.name}
                  </span>
                ) : (
                  "Glisser ou cliquer pour charger"
                )}
              </p>
              <p className="text-xs text-gray-400">.xlsx ou .csv uniquement</p>
              <input
                type="file"
                id="fichier"
                onChange={handleChangeFichier}
                accept=".xlsx,.csv"
                className="hidden"
              />
            </div>
          </label>

          <div className="flex items-center gap-2 mt-4">
            <a
              href={model}
              download="modelServicePartner"
              className="h-9 px-4 flex items-center gap-1.5 border border-gray-200 rounded-lg text-xs font-medium text-gray-700 hover:bg-gray-50 transition"
            >
              Télécharger le modèle
            </a>
            <button
              onClick={() => {
                setIsSubmit(true);
                store(CHARGER_LISTE_SERVICE_PARTNER, "multipart/form-data", {
                  fichier: fichier[0],
                })
                  .then((res) => {
                    if (res.status === 200) {
                      setIsSubmit(null);
                      document.getElementById("close_upload").click();
                      servicePartner.getData(
                        `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`,
                      );
                      toast.success("Fichier chargé avec succès");
                    }
                  })
                  .catch((err) => {
                    setIsSubmit(false);
                    setMessage(err?.response?.data?.donnee);
                  });
              }}
              disabled={isSubmit || fichier.length === 0}
              className={`ml-auto h-9 px-4 rounded-lg text-xs font-semibold flex items-center gap-2 transition ${
                isSubmit || fichier.length === 0
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-yellow-400 hover:bg-yellow-300 text-gray-900"
              }`}
            >
              {isSubmit ? (
                <>
                  <span className="loading loading-spinner loading-xs" />{" "}
                  Chargement…
                </>
              ) : (
                "Charger le fichier"
              )}
            </button>
          </div>
        </div>
      </dialog>

      {/* Add Modal */}
      <dialog id="add" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              Nouveau service partner
            </h2>
            <form method="dialog">
              <button
                id="fermer_create_role"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition"
              >
                ✕
              </button>
            </form>
          </div>
          <form onSubmit={handleSubmit(submit)} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Désignation <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className={inputCls}
                {...register("designation", { required: true })}
              />
              {errors.designation && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>
            <button
              type="submit"
              disabled={isSubmit}
              className={`w-full h-10 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition ${
                isSubmit
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-yellow-400 hover:bg-yellow-300 text-gray-900"
              }`}
            >
              {isSubmit ? (
                <>
                  <span className="loading loading-spinner loading-xs" />{" "}
                  Enregistrement…
                </>
              ) : (
                "Enregistrer"
              )}
            </button>
          </form>
        </div>
      </dialog>

      {/* Update Modal */}
      <dialog id="upadate" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              Modifier le service partner
            </h2>
            <form method="dialog">
              <button
                id="fermer"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition"
              >
                ✕
              </button>
            </form>
          </div>
          <UpdateServicePartner item={selectItem} />
        </div>
      </dialog>

      {/* Delete Modal */}
      <dialog id="delete" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <p className="text-base font-bold text-gray-900 mb-1">
            Confirmer la suppression
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Le service partner{" "}
            <span className="font-semibold text-gray-800">
              {selectItem?.designation}
            </span>{" "}
            sera définitivement supprimé.
          </p>
          <div className="flex justify-end gap-2">
            <form method="dialog">
              <button className="h-9 px-4 rounded-lg text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-700 transition">
                Annuler
              </button>
            </form>
            <button
              onClick={() => {
                setIsDeleting(true);
                clientAxios
                  .delete(`${DELETE_SERVICE_PARTNER}/${selectItem.id}`)
                  .then(() => {
                    servicePartner.getData(
                      `${RECHERCHER_SERVICE_PARTNER}?page=0&param=&size=10`,
                    );
                    toast.success("Service partner supprimé");
                    document.getElementById("delete").close();
                  })
                  .catch((err) =>
                    toast.error(
                      err?.response?.data?.donnee ||
                        "Erreur lors de la suppression",
                    ),
                  )
                  .finally(() => setIsDeleting(false));
              }}
              disabled={isDeleting}
              className={`h-9 px-4 rounded-lg text-sm font-medium flex items-center gap-2 transition ${
                isDeleting
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-red-500 hover:bg-red-600 text-white"
              }`}
            >
              {isDeleting && (
                <span className="w-3.5 h-3.5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              )}
              {isDeleting ? "Suppression…" : "Supprimer"}
            </button>
          </div>
        </div>
      </dialog>

      {/* Grid */}
      {servicePartner?.loading ? (
        <Loader />
      ) : servicePartner?.data?.donnee?.data?.length === 0 ? (
        <div className="flex items-center justify-center h-48">
          <p className="text-sm text-gray-400">Aucun service partner trouvé</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
          {servicePartner?.data?.donnee?.data?.map((item) => (
            <div
              key={item.id}
              className="relative bg-white border border-gray-200 rounded-xl p-3 flex items-center gap-3 hover:shadow-md hover:border-yellow-300 transition-all duration-200"
            >
              {/* Menu */}
              <div className="dropdown dropdown-end absolute top-2 right-2">
                <div
                  tabIndex={0}
                  role="button"
                  className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500 transition cursor-pointer"
                >
                  <MoreHorizontal size={15} />
                </div>
                <ul
                  tabIndex={0}
                  className="dropdown-content z-10 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg w-40 p-1.5"
                >
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-gray-700 rounded-lg hover:bg-gray-50 transition"
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("upadate").showModal();
                      }}
                    >
                      Modifier
                    </button>
                  </li>
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-red-600 rounded-lg hover:bg-red-50 transition"
                      onClick={() => {
                        setSelectItem(item);
                        document.getElementById("delete").showModal();
                      }}
                    >
                      Supprimer
                    </button>
                  </li>
                </ul>
              </div>

              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center shrink-0 text-gray-500">
                <WorkHistoryIcon size={18} />
              </div>

              {/* Info */}
              <p className="text-xs font-semibold text-gray-900 truncate flex-1 pr-6">
                {item?.designation}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-end mt-6">
        <Pagination
          onChange={(_, v) => more(v)}
          count={servicePartner.data?.donnee?.totalPages}
          variant="outlined"
          color="primary"
          shape="rounded"
          size="small"
        />
      </div>
    </>
  );
};
